import { render, staticRenderFns } from "./SlideContent.vue?vue&type=template&id=3c4d062a&scoped=true&"
import script from "./SlideContent.vue?vue&type=script&lang=js&"
export * from "./SlideContent.vue?vue&type=script&lang=js&"
import style0 from "./SlideContent.vue?vue&type=style&index=0&id=3c4d062a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4d062a",
  null
  
)

export default component.exports